<template>
    <div>
        <CommonPop v-model="show" title="Amount Due">
            <div class="channel">
                <div class="channel-top">
                    <p
                        class="channel-acount"
                        v-html="
                            $t(getBonus ? 'wallet_detail_info1' : 'wallet_detail_info2', {
                                current_type: store.cureencySymbol(),
                                current_number1: (product?.cny || 0) + (product.gifts?.gold || 0),
                                current_number2: getBonus,
                            })
                        "
                    ></p>
                </div>
                <div class="channel-area">
                    <div class="channel-title">{{ $t('Wallet_deposit_method') }}</div>
                    <div class="channel-list">
                        <div
                            :class="['channel-item', { cantChoose: item.status === 0 }, { active: chooseChl === item?.channel }]"
                            v-for="item in takeEffectChannel"
                            :key="item?.channel"
                            @click="changeChannel(item)"
                        >
                            <div class="channel-left">
                                <div class="pay-wrap">
                                    <img :src="item.payicon" />
                                </div>
                                <div v-if="$t(item?.channel)" class="icon-wrap">
                                    <img :src="item.icon" />
                                    <p class="channel-text" v-html="$t(item?.channel)"></p>
                                </div>
                            </div>
                            <div class="channel-right">
                                <div v-if="item.status === 0" class="maintenance"></div>
                                <div class="channel-check" v-else></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="channel-btn" @click="confirm">{{ $t('Deposit') }} {{ store.cureencySymbol() + finalAmount }}</div>
            </div>
        </CommonPop>
        <van-overlay class="flex flex-col items-center justify-center" :show="showLoading" :z-index="6000">
            <div><van-loading type="spinner" /></div>
            <div class="loading-tip">{{ $t('Order_is_being_gener') }}</div>
        </van-overlay>
        <Reseller v-if="showReseller" v-model="showReseller" />
    </div>
</template>
<script setup lang="ts">
import { getAllChannels, createPaysoOrder } from '@/api/wallet'
import { useBaseStore } from '@/stores'
import { getDeviceInfo } from '@/utils'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import popupManager from '@/utils/PopupManager'
import { useI18n } from 'vue-i18n'
import Reseller from '@/components/dialog/reseller.vue'
import CommonPop from '@/components/dialog/commonPopup.vue'

const store = useBaseStore()
const router = useRouter()

const show = defineModel()
const emit = defineEmits(['recharged', 'sendChannel', 'createOrderFailed', 'closed'])
const i18n = useI18n()

const chooseChl = ref('')
const showLoading = ref(false)
const orderParams = inject('orderParams') as any
const showReseller = ref(false)

const product = computed(() => orderParams.item)
const finalAmount = computed(() => {
    return orderParams.finalAmount || orderParams.item?.cny
})

const vipProduct = computed(() => {
    return orderParams.source === 'wallet' && store.curVipConfig?.depositBonus
})

const takeEffectChannel = computed(() => {
    const id = product.value?.id
    if (!id) {
        return []
    }
    return id ? store.depositeChannel.filter((item) => item.productList.includes(id)) : store.depositeChannel
})

const uid = computed(() => {
    return store.userInfo.uid
})
const getBonus = computed(() => {
    let bonus = product.value?.gifts?.bonus || 0
    const cny = product.value?.cny
    if (vipProduct.value) {
        bonus = bonus + Number((cny * store.curVipConfig?.depositBonus).toFixed(4))
    }
    return Number(bonus.toFixed(2)) || 0
})
const isDialog = computed(() => {
    return ['onlinesign', 'firstpayment'].includes(orderParams.source)
})

const getChannel = async () => {
    if (!uid.value || !store.token) {
        return
    }
    const res = await getAllChannels(uid.value, false)
    if (res.code === 200) {
        store.depositeChannel = store.userInfo?.isReseller ? res.result.filter((item) => item.channel !== 'reseller') : res.result
        emit('sendChannel', res.result)
    }
}
const getVipInfo = async () => {
    try {
        const info = await store.getVipInfo(false, false)
        if (info.code === 200) {
            store.setvipInfo(info)
        }
    } catch (e) {
        console.log(e)
    }
}
watch(show, () => {
    show.value && getChannel()
    getVipInfo()
})
watch(takeEffectChannel, () => {
    if (!takeEffectChannel.value.some((item) => item.channel == chooseChl.value)) {
        chooseChl.value = takeEffectChannel.value[0]?.channel
    }
})
watch(
    () => store.wallet?.currency,
    (oldVal, newVal) => {
        if (oldVal === newVal) {
            return
        }
        getChannel()
    }
)

const changeChannel = (item) => {
    if (item.status === 0) {
        return
    }
    chooseChl.value = item?.channel
}
const confirm = async () => {
    if (takeEffectChannel.value.every((item) => item.status === 0)) {
        store.showFailToast(i18n.t('wallet_deposit_tier_unavailable'))
        return
    }
    if (chooseChl.value === 'reseller') {
        return (showReseller.value = true)
    }

    showLoading.value = true
    try {
        const orderData: any = {
            uid: store.userInfo.uid,
            productId: product.value.id,
            channel: chooseChl.value,
            osType: getDeviceInfo().os,
            tradeType: 'H5',
            redirectUrl: location.href,
            source: product.value?.usefor || '',
            toBoostRelief: product.value?.toBoostRelief || false,
        }
        // 如果有优惠券则添加到订单数据中
        if (orderParams.couponInstanceId) {
            orderData.couponInstanceId = orderParams.couponInstanceId
        }
        const order = await createPaysoOrder(orderData)
        if (order.code === 200) {
            const url = order.body.guideUrl
            if (isDialog.value) {
                store.depositOrder = order.body.orderId
            }
            if (chooseChl.value === 'wkqrpay') {
                router.push({
                    path: '/payGuide',
                    query: {
                        u: encodeURIComponent(url),
                        coin: product.value.cny,
                        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    },
                })
                show.value = false
                if (!isDialog.value) {
                    popupManager.checkQueue()
                }
                return
            }
            if (url && url.startsWith('http')) {
                location.href = url
                // window.open(url)
                // showDialog({
                //     message: '111111',
                //     className: 'common-dialog',
                //     showCancelButton: true,
                //     confirmButtonText: i18n.t('Confirm'),
                //     cancelButtonText: i18n.t('Cancel'),
                // }).then(() => {
                //     window.open(url)
                // })
            }
            show.value = false
            handleClose()
            emit('recharged')
            if (!isDialog.value) {
                popupManager.checkQueue()
            }
        } else {
            emit('createOrderFailed', order)
        }
    } catch (e) {
        console.log(e)
        emit('createOrderFailed', e)
    } finally {
        showLoading.value = false
    }
}
const handleClose = () => {
    emit('closed')
}

onBeforeMount(() => {
    getChannel()
})
</script>
<style lang="scss" scoped>
.channel {
    padding: 0 21px 84px;
    // height: 945px;
    color: #fff;

    .channel-top {
        padding-bottom: 20px;
        .channel-acount {
            color: #fff;
            font-family: 'Microsoft YaHei';
            font-size: 32px;
            font-style: normal;
            font-weight: 600;
            text-align: center;
            line-height: 80px;

            :deep(span) {
                color: #fe588a;
            }
        }

        // .channel-acount {
        //     font-size: 60px;
        //     font-weight: bold;
        //     color: #ffea76;
        //     text-align: center;
        // }
        // .channel-give {
        //     display: flex;
        //     font-size: 30px;

        //     .give-left {
        //         flex: 1;
        //         color: #fff;
        //     }
        //     .give-num {
        //         color: #ffea76;
        //     }
        // }
    }
    .channel-area {
        padding-top: 40px;
        height: 523px;
        background-color: #1c1b28;
        border-radius: 10px;
        overflow-y: auto;
        .channel-title {
            @apply flex items-center justify-center gap-[20px];
            margin-bottom: 23px;
            font-size: 30px;
            text-align: center;
            color: #fff;
            background: url('@/assets/img/wallets/channel_line.png') no-repeat center center;
            background-size: 505px 4px;

            // &::before,
            // &::after {
            //     content: '';
            //     display: inline-block;
            //     width: 160px;
            //     height: 4px;
            //     background: url('@/assets/img/wallets/channel_line.png') no-repeat;
            //     background-size: 100% 100%;
            // }
        }
        .channel-list {
            padding: 0 20px;
            .channel-item {
                display: flex;
                margin-bottom: 30px;
                height: 100px;
                background-color: #3e4456;
                border-radius: 20px;

                .channel-left {
                    position: relative;
                    display: flex;
                    align-items: center;
                    flex: 1;

                    .pay-wrap {
                        @apply flex items-center;
                        padding-left: 18px;
                        margin-right: 10px;
                        width: 286px;
                        height: 100%;

                        img {
                            height: 60px;
                        }
                    }
                    .icon-wrap {
                        flex: 1;
                        .channel-text {
                            position: absolute;
                            left: 290px;
                            top: 50%;
                            padding-left: 18px;
                            font-size: 28px;
                            line-height: 30px;
                            color: #ffffff;

                            transform: translateY(-50%);
                        }
                        img {
                            height: 60px;
                        }
                    }
                }
                &.cantChoose {
                    .channel-left {
                        opacity: 0.3;
                    }
                }
                .channel-right {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 68px;
                    padding-right: 20px;

                    .maintenance {
                        width: 100%;
                        height: 48px;

                        background: url('@/assets/img/wallets/maintenance.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .channel-check {
                        width: 36px;
                        height: 36px;
                        background-color: #2a2d3d;
                        border-radius: 50%;
                    }
                }

                &.active {
                    .channel-check {
                        position: relative;
                        background-color: #10c580;

                        &::before {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            content: '';
                            width: 27px;
                            height: 21px;
                            transform: translate3d(-50%, -50%, 0);
                            background: url('@/assets/img/wallets/channel_active.png') no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }
    }
    .channel-btn {
        margin: 50px auto 0;
        width: 560px;
        height: 100px;
        line-height: 100px;
        background-image: linear-gradient(0deg, #fa3374 0%, #fd578d 60%, #ff7aa5 100%), linear-gradient(#e59e20, #e59e20);
        background-blend-mode: normal, normal;
        border-radius: 50px;
        font-size: 36px;
        text-align: center;
        color: #fff;
    }
}
.loading-tip {
    margin-top: 10px;
    font-size: 27px;
    color: #fff;
}
</style>
<style lang="scss">
.tip-error {
    transform: translateY(100%) !important;
}
</style>
